import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import axiosInstance from '../utils/axiosConfig';

const BulkOrderPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    contactNumber: '',
    email: '',
    city: '',
    userType: '',
    requirements: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post('/bulk-orders', formData);
      setFormData({
        name: '',
        contactNumber: '',
        email: '',
        city: '',
        userType: '',
        requirements: '',
      });
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <div>
      <div style={{ position: 'relative', height: '702px', width: '100%' }}>
        <video autoPlay muted loop playsInline style={{ height: '100%', width: '100%', objectFit: 'cover' }}>
          <source src="/cargo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          color: 'white',
          textAlign: 'center',
          width:'100%'
        }}
      >
        <h1 className="display-2 fw-bold">Furnish Big. Save Bigger.</h1>
        <p className="fs-3 lead">
          Get amazing deals on bulk furniture orders for offices,<br /> startups, and more. Custom-made just for you.
        </p>
      </div>
      </div>  


      <Container className="py-5">
        <Row className="align-items-center mb-5">
        <Col md={6}>
            <h1 className="display-4 mb-4 fw-bold">MULTIPLE ADVANTAGES FOR BULK ORDERS</h1>
            <ul className="list-unstyled">
              <li className="mb-3">
                <span className="me-2">✓</span>
                Attractive discounts.
              </li>
              <li className="mb-3">
                <span className="me-2">✓</span>
                Customisation of products in terms of sizes, finishes & materials.
              </li>
              <li className="mb-3">
                <span className="me-2">✓</span>
                We also provide you furniture layout to optimise your office space utilisation.
              </li>
            </ul>
          </Col>
          <Col md={6}>
            <img
              src="/images/bulk-order-office.jpeg"
              alt="Modern office space"
              className="img-fluid rounded"
              style={{ width: '100%', height: 'auto' }}
            />
          </Col>
   
        </Row>

        <Form onSubmit={handleSubmit} className="bg-light p-4 rounded-3 shadow-sm">
          <Row className="mb-4">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  placeholder="Your name"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Contact Number <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="tel"
                  name="contactNumber"
                  value={formData.contactNumber}
                  onChange={handleInputChange}
                  required
                  placeholder="Your contact number"
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Email Address <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  placeholder="Your email address"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>City <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  required
                  placeholder="Your city"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-4">
            <Form.Label>What describes you best</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                name="userType"
                value="interior_designer"
                label="I am an interior designer/architect"
                checked={formData.userType === 'interior_designer'}
                onChange={handleInputChange}
              />
              <Form.Check
                inline
                type="radio"
                name="userType"
                value="home_office"
                label="I am buying for my home/office"
                checked={formData.userType === 'home_office'}
                onChange={handleInputChange}
              />
              <Form.Check
                inline
                type="radio"
                name="userType"
                value="business"
                label="I am buying for business"
                checked={formData.userType === 'business'}
                onChange={handleInputChange}
              />
              <Form.Check
                inline
                type="radio"
                name="userType"
                value="other"
                label="Other"
                checked={formData.userType === 'other'}
                onChange={handleInputChange}
              />
            </div>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>Requirements</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="requirements"
              value={formData.requirements}
              onChange={handleInputChange}
              placeholder="Please share dimensions or layout of your space along with requirement.
  We can offer you furniture layout with optimal space utilisation.
  We offer customised furniture options hence please share details of your requirement with ref images.
  We will try and match it as close as possible"
            />
          </Form.Group>

          <div className="text-center">
            <Button 
              type="submit" 
              variant="primary" 
              size="lg"
            >
              SUBMIT
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default BulkOrderPage; 